import { get, post, put, del } from "@/util/request";

/**
 * 分页获取工伤单位
 * @param {*} data
 * @returns
 */
export const PostGetData_IndustrialUnit = (data) => {
  return post("/api/IndustrialUnit/Select", data, {});
};

/**
 * 分页获取受伤部位
 * @param {*} data
 * @returns
 */
export const PostGetData_InjurySite = (data) => {
  return post("/api/InjurySite/Select", data, {});
};

/**
 * 分页获取专区列表
 * @param {*} data
 * @returns
 */
export const getDataByPageQuery = (data) => {
  return post("/api/app/homePage/getDataByPageQuery", data, {});
};
/**
 * 更新专区状态
 * @param {*} data
 * @returns
 */
export const changeHomePageStatus = (data) => {
  return put("/api/app/homePage", data, {});
};
/**
 * 删除专区
 * @param {*} id
 * @returns
 */
export const deleteHomePage = (id) => {
  return del("/api/app/homePage/" + id, {}, {});
};

/**
 * 新增专区
 * @param {*} data
 * @returns
 */
export const addHomePage = (data) => {
  return post("/api/app/homePage/", data, {});
};
/**
 * 获取明细
 * @param {*} id
 * @returns
 */
 export const HomePageDetail = (id) => {
  return post("/api/app/homePage/" + id+"/getModel", {}, {});
};
/**
 * 编辑专区
 * @param {*} data
 * @returns
 */
 export const editHomePage = (data) => {
  return post("/api/app/homePage/modify", data, {});
};

/**
 * 获取课程列表
 * @param {*} data
 * @returns
 */
 export const getClassList = (data) => {
  return post("/api/app/Course/getDataByPageQuery", data, {});
};

/**
 * 获取课程列表
 * @param {*} data
 * @returns
 */
 export const getCategoryList = (data) => {
  return post("/api/app/courseCategory/wXGetCourseCategoryList", data, {});
};

/**
 * 获取首页专区（父子结构）
 * @returns
 */
export const getHomePageZones = () => {
  return post("/api/app/homePage/getHomePageZones", {}, {});
};





